import CacheService from '@fs/zion-cache-service'

const cacheDefaults = {
  storeName: 'permissions',
  type: 'session',
  lifetime: 1000 * 60 * 5 /* 5 minutes */,
}
// Note: When a zion-cache instance is created, pass that into CacheService instead of cacheDefaults
const cacheService = new CacheService({ cache: cacheDefaults })

export default cacheService
